import { render, staticRenderFns } from "./Details.vue?vue&type=template&id=4d3de5bb&scoped=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"
import style0 from "./Details.vue?vue&type=style&index=0&id=4d3de5bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3de5bb",
  null
  
)

export default component.exports